import * as _ from 'lodash';
import { Formatter } from 'slickgrid';
import Handlebars, { Exception } from 'handlebars';
import { ro } from 'date-fns/locale';

const interpolate = /{{([\s\S]+?)}}/g;

export interface TemplateFormatterOptions {
  format: string;
  engine?: string;
}

const normalizeFormat = (value: string) => {
  if (value.startsWith('#!')) {
    return value.substring(2);
  }
  return value;
};

function stripHtmlTags(input: string): string {
  return (
    input
      // Replace tags with a space
      .replace(/<[^>]*>/g, ' ')
      // Collapse multiple spaces into one
      .replace(/\s+/g, ' ')
      // Trim leading/trailing spaces
      .trim()
  );
}

export function template<T>(opts: TemplateFormatterOptions): Formatter<T> {
  if (opts.engine == 'hb') {
    return handlebarsTemplateFormatter(opts);
  }

  const textFormat = _.template(opts.format, { interpolate });

  function templateFormatter(row, cell, value, columnDef, data) {
    if (data) {
      return textFormat({
        $value: _.get(data, columnDef.field),
        ...data,
      });
    }
    return '';
  }

  templateFormatter.exportDataFormatter = function (
    row,
    cell,
    value,
    columnDef,
    data,
  ) {
    return stripHtmlTags(
      templateFormatter(row, cell, value, columnDef, data) || '',
    );
  };

  templateFormatter.filterFormattedValue = true;

  return templateFormatter;
}

function handlebarsTemplateFormatter<T>(
  opts: TemplateFormatterOptions,
): Formatter<T> {
  const template = Handlebars.compile(normalizeFormat(opts.format));

  function templateFormatter(row, cell, value, columnDef, data) {
    if (data) {
      try {
        return template({
          $value: _.get(data, columnDef.field),
          ...data,
        });
      } catch (err) {
        return `#ERROR ${err}`;
      }
    }
    return '';
  }

  templateFormatter.exportDataFormatter = function (
    row,
    cell,
    value,
    columnDef,
    data,
  ) {
    return stripHtmlTags(
      templateFormatter(row, cell, value, columnDef, data) || '',
    );
  };

  templateFormatter.filterFormattedValue = true;

  return templateFormatter;
}
